import { ROUTES } from '@/constants/routes'

export default function isAccountDisabled({ next, router, store }) {
    const { workspace = {}, getWorkspaceSlug } = store

    if (workspace && !workspace?.owner_blocked) {
        return router.push({ name: ROUTES.reporting, params: { workspace: getWorkspaceSlug } })
    }

    next()
}
